import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import _throttle from "lodash/throttle";
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-haut.svg';
var SCROLL_THRESHOLD = 230;
export default {
  name: 'MdmBackToTop',
  data: function data() {
    return {
      show: false
    };
  },
  mounted: function mounted() {
    this.show = window.scrollY > SCROLL_THRESHOLD;
    this.bindScrollTop();
  },
  destroyed: function destroyed() {
    this.unbindScrollTop();
  },
  methods: {
    scrollTop: function scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    bindScrollTop: function bindScrollTop() {
      window.addEventListener('scroll', this.handleScroll, {
        passive: true
      });
    },
    unbindScrollTop: function unbindScrollTop() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    handleScroll: _throttle(function handleScroll() {
      this.show = window.scrollY > SCROLL_THRESHOLD;
    }, 200)
  }
};